import React from "react";
import { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";

import GeneralNavbar from "../../components/Navbar/GeneralNavbar";

import "./MembersPage.css";

// Import the JSON files that contain the information for each member
import pi from "./lists/pi.json";
import postdoc from "./lists/postdoc.json";
import phd_candidate from "./lists/phd_candidate.json";
import postgrad from "./lists/postgrad.json";
import ra from "./lists/ra.json";
import alumnis from "./lists/alumnis.json";

/**
 * Renders an image dynamically based on the provided image name.
 * @param {string} props.imageName - The name of the image to be rendered.
 * @returns {JSX.Element|null} The rendered image element or null if the image cannot be found.
 */
const DynamicImage = ({ imageName }) => {
	const importImage = (imagePath) => {
		try {
			return require(`${imagePath}`);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	const imagePath = importImage(imageName);
	return (
		imagePath && <img src={imagePath} alt={`${imageName.split(".")[0]}`} />
	);
};

// Renders a member card
const MemberCard = ({ name, picture, email, position }) => {
	return (
		<div className="card-container">
			<DynamicImage imageName={picture} />
			<div className="card-info">
				<div className="card-name">{name}</div>
				<div className="card-position">{position}</div>
			</div>
			{email && (
				<ul className="email-icon">
					<a href={`mailto:${email}`}>
						<i className="fas fa-envelope"></i>
					</a>
				</ul>
			)}
		</div>
	);
};

// Renders a section of members
const MembersSection = ({ title, members }) => {
	return (
		<div className="member-section-container">
			<div className="member-section-heading">{title}</div>
			<div className="member-section-underline"></div>
			<div className="all-card-container">
				{members.map((member) => (
					<MemberCard
						key={member.email}
						name={member.name}
						email={member.email}
						title={member.title}
						position={member.position}
						picture={member.picture}
					/>
				))}
			</div>
		</div>
	);
};

const MembersPage = () => {
	useEffect(() => {
		// change background color when component mounts
		document.body.style.backgroundColor = "white";

		// reset background color when component unmounts
		return () => {
			document.body.style.backgroundColor = "rgb(0, 53, 107)";
		};
	}, []);

	return (
		<>
			<GeneralNavbar />
			<div className="member-page-container">
				<div className="member-page-heading">Members</div>
				<Tabs defaultActiveKey="current" className="mb-3 custom-tab">
					<Tab eventKey="current" title="Current Members">
						<MembersSection
							title="Principal Investigator"
							members={pi}
						/>
						<MembersSection
							title="Postdoctoral Associates"
							members={postdoc}
						/>
						<MembersSection
							title="PhD Candidates"
							members={phd_candidate}
						/>
						<MembersSection
							title="Postgraduate Fellows"
							members={postgrad}
						/>
						<MembersSection
							title="Research Assistants"
							members={ra}
						/>
					</Tab>
					<Tab eventKey="alumni" title="Alumni">
						<MembersSection title="Alumni" members={alumnis} />
					</Tab>
				</Tabs>
			</div>
		</>
	);
};

export default MembersPage;
